/**
 * How an order is being run on the POS — the discriminator the Tab Mode board
 * and reporting read. `tabName` cannot serve: it is also the table label.
 *
 *   - `table`   — opened from Table Service
 *   - `tab`     — a bar tab opened from Tab Mode (still `OrderType.dineIn`)
 *   - `takeout` — opened from Takeout Order Mode
 *
 * OPTIONAL, ALWAYS. An order without it is a legacy order (or one written
 * while `initiative.service_modes` is off) and must read exactly as before.
 * It does not replace `type` (`OrderType` reaches Postgres and stays as is).
 */
export const ORDER_SERVICE_MODES = ["table", "tab", "takeout"] as const;
export type OrderServiceMode = (typeof ORDER_SERVICE_MODES)[number];

/**
 * Tolerant read: a known mode comes back as is; absent, null or anything
 * unrecognised (a newer POS build's mode, a typo) reads as `undefined`
 * (legacy) rather than failing the whole order.
 */
export function parseOrderServiceMode(raw: unknown): OrderServiceMode | undefined {
  return typeof raw === "string" && (ORDER_SERVICE_MODES as readonly string[]).includes(raw)
    ? (raw as OrderServiceMode)
    : undefined;
}
